/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Mandatory_Tech_SkillsInputs */

const en_job_form_mandatory_tech_skills = /** @type {(inputs: Job_Form_Mandatory_Tech_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandatory Tech Skills`)
};

const de_job_form_mandatory_tech_skills = /** @type {(inputs: Job_Form_Mandatory_Tech_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbedingt erforderliche IT-Kenntnisse`)
};

/**
* | output |
* | --- |
* | "Mandatory Tech Skills" |
*
* @param {Job_Form_Mandatory_Tech_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_mandatory_tech_skills = /** @type {((inputs?: Job_Form_Mandatory_Tech_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Mandatory_Tech_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_mandatory_tech_skills(inputs)
	return en_job_form_mandatory_tech_skills(inputs)
});